export default __webpack_public_path__ + "static/media/trackreclogo.1ff49ba6.png";